module.exports = __webpack_public_path__ + "img/article-2.48ca80f7.jpg";